import { render, staticRenderFns } from "./AchatServiceReference.vue?vue&type=template&id=33f5e60c"
import script from "./AchatServiceReference.vue?vue&type=script&lang=js"
export * from "./AchatServiceReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports